export function noop() {}

export const inBrowser = typeof document !== "undefined" && !!document.scripts
export const inWechat = process.env.VNMF_ENV === "weapp"
export const inSwan = process.env.VNMF_ENV === "swan"
export const inAlipay = process.env.VNMF_ENV === "alipay"
export const inQQ = process.env.VNMF_ENV === "qq"
export const inToutiao = process.env.VNMF_ENV === "tt"
